module.exports = __webpack_public_path__ + "img/icons BFr_39.ad1577d6.png";